import React from 'react';
import classes from './BtnBlue.module.scss';
const BtnBlue = ({ text, fullWidth, high, type, onClick, disabled, loading, icon, style }) => {
    var _a;
    const classList = (_a = `${classes.btnBlue} ${fullWidth !== undefined && fullWidth ? classes.btnFull : ''} ${high !== undefined && high ? classes.high : ''} ${disabled ? classes.disabled : ''} ${loading ? classes.loading : ''}`) === null || _a === void 0 ? void 0 : _a.trim();
    return (React.createElement("button", { style: style, type: type, onClick: onClick, className: classList },
        icon,
        text));
};
export default BtnBlue;
